import React from 'react';
import { Modal, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { UserDisplay } from '../../../../pages/users/types/UserDisplay';
import './ReactivateUserModal.css';

interface ReactivateUserModalProps {
  isOpen: boolean;
  user: UserDisplay | null;
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ReactivateUserModal: React.FC<ReactivateUserModalProps> = ({
  isOpen,
  user,
  isLoading = false,
  onCancel,
  onConfirm,
}) => {
  if (!user) return null;

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      centered
      width={612}
      className="reactivate-user-modal"
      closable={false}
    >
      <div className="reactivate-user-modal__content">
        <div className="reactivate-user-modal__header">
          <InfoCircleOutlined className="reactivate-user-modal__icon" />
          <h3 className="reactivate-user-modal__title">Réactiver l'utilisateur ?</h3>
        </div>

        <p className="reactivate-user-modal__description">
          Cette action est immédiate. <strong>{user.name}</strong> retrouvera l'accès à son compte.
        </p>

        <div className="reactivate-user-modal__info-box">
          <h4 className="reactivate-user-modal__info-title">Effets de la réactivation</h4>
          <ul className="reactivate-user-modal__info-list">
            <li>L'utilisateur récupère l'accès au dashboard</li>
            <li>Un numéro de téléphone devra lui être assigné</li>
            <li>Les données et l'historique sont intégralement restaurés</li>
          </ul>
        </div>

        <div className="reactivate-user-modal__actions">
          <Button className="reactivate-user-modal__cancel-btn" onClick={onCancel}>
            Annuler
          </Button>
          <Button
            type="primary"
            className="reactivate-user-modal__confirm-btn"
            onClick={onConfirm}
            loading={isLoading}
          >
            Réactiver l'utilisateur
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ReactivateUserModal;
